import { render, staticRenderFns } from "./booked-seats.vue?vue&type=template&id=ec13f2fa&scoped=true&"
import script from "./booked-seats.vue?vue&type=script&lang=js&"
export * from "./booked-seats.vue?vue&type=script&lang=js&"
import style0 from "./booked-seats.vue?vue&type=style&index=0&id=ec13f2fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec13f2fa",
  null
  
)

export default component.exports